import { View } from "react-native";
import BlocksAvatar from "@/src/components/ui-kit/blocks-avatar";
import { useGetGroupMemberAvatars } from "@/src/services/api/groups/groups.hooks";

type GroupHeaderAvatarsProps = Readonly<{
  groupId: string;
}>;

const GroupHeaderAvatars = ({ groupId }: GroupHeaderAvatarsProps) => {
  const { data: avatars = [] } = useGetGroupMemberAvatars(groupId, 3);

  if (!avatars.length) return null;

  return (
    <View className="flex-row items-center">
      {avatars.map((member, index) => (
        <BlocksAvatar
          key={member.userId}
          userId={member.userId}
          fallbackImageUrl={member.profileImageUrl}
          name={member.name}
          size={20}
          className={`border border-white ${
            index === avatars.length - 1 ? "" : "-mr-1"
          }`}
        />
      ))}
    </View>
  );
};

export default GroupHeaderAvatars;
